import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'

declare interface RouteInfo {
  title: string
  subtext: string
  subtext2: string
  subtext3: string
  text: string
  text2: string
  text3: string
}
export const Summary: RouteInfo[] = [
  {
    subtext:
      "The California Hispanic Chambers of Commerce (CHCC) and its 120 Hispanic and diverse chambers and business association members represent the interest of over 850,000 Hispanic-owned businesses in California. The CHCC serves as the voice of California's diverse small business community, bringing the issues and needs impacting Hispanic and diverse small businesses and communities to the forefront of California and National economic agendas.",
    subtext2:
      "The CHCC focuses its proactive education, advocacy, and empowerment efforts on programs and policies that answer and meet the needs and priorities of California's diverse small businesses and Hispanic community. As the nation's leading regional Hispanic and diverse business organization, the CHCC has been the voice for Hispanic and diverse business owners in California for over forty years. From its inception, the CHCC has been committed to fostering economic growth that creates and sustains prosperity for the benefit of California's economy and our communities.",
    title: 'CHCC History',
    subtext3:
      'In 1978, a group of local Hispanic chamber leaders from throughout California convened to discuss the lack of representation of Hispanic businesses in state government. These leaders also recognized the need for an organization that could effectively represent the rapidly growing number of Hispanic-owned companies in California.',
    text:
      "For over forty years, the CHCC has actively promoted the economic growth, development, and interests of California's more than 850,000 Hispanic-owned businesses. ",
    text2:
      "Today, the California Hispanic Chambers of Commerce is the largest regional Hispanic and ethnic business organization advocating and educating diverse small businesses nationwide. Through its 120 chambers and business association members, the CHCC provides advocacy, education, and empowerment programs to California's Hispanic and small business communities. ",
    text3: '',
  },
]
export const HistoryLists: RouteInfo[] = [
  {
    text: '1978 - 1982',
    text2: 'Larry Garcia',
    text3: 'Sacramento, CA',
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '1982 - 1985',
    text2: 'Sergio Banuelos',
    text3: 'Los Angeles, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '1985 - 1987',
    text2: 'Roy Jasso',
    text3: 'Stockton, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '1987 - 1990',
    text2: 'Armando Morlos',
    text3: 'Fremont, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '1990 - 1991',
    text2: 'Joe Partida',
    text3: 'Oakland, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '1991 - 1996',
    text2: 'Manuel Rosales',
    text3: 'San Francisco, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '1996 - 1999',
    text2: 'Andrew Ysiano',
    text3: 'Stockton, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '1999 - 2000',
    text2: 'Alex Torres',
    text3: 'San Jose, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '2000 - 2001',
    text2: 'Raul Medrano',
    text3: 'Orange County, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '2001- 2005',
    text2: 'Melinda Guzman',
    text3: 'Sacramento, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '2005 - 2007',
    text2: 'Henry Mendoza',
    text3: 'Orange County, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '2007 - 2011',
    text2: 'Kenneth Macias',
    text3: 'Sacramento, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '2011 - 2012',
    text2: 'Roy Perez',
    text3: 'Sacramento, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '2012 - 2013',
    text2: 'Ernesto Gutierrez',
    text3: 'Los Angeles, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '2013 - 2014',
    text2: 'Ken Macias',
    text3: 'Sacramento, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '2014 - 2015',
    text2: 'Manuel Cosme',
    text3: 'Vacaville, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '2015 - 2019',
    text2: 'Frank Montes',
    text3: 'Fontana, CA',
  },
  {
    title: '',
    subtext: '',
    subtext2: '',
    subtext3: '',
    text: '2019 - Present',
    text2: 'Robert Gutierrez',
    text3: 'Stockton, CA',
  },
]
@Component({
    selector: 'app-about-chcc',
    templateUrl: './about-chcc.component.html',
    styleUrls: ['./about-chcc.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AboutCHCCComponent implements OnInit {
  mainTitle = 'About the California Hispanic Chambers of Commerce'
  histories: any = []
  summaries: any = []

  constructor() {}

  ngOnInit(): void {
    this.summaries = Summary.filter((summary) => summary)
    this.histories = HistoryLists.filter((history) => history)
  }
}
